module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp2_8019.36c62ffa.png";